// @ts-nocheck
import * as React from "react";

const PrinterFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M16 8.615v-3H8v3H7v-4h10v4h-1Zm1.615 3.5c.283 0 .52-.095.712-.287a.968.968 0 0 0 .288-.712.968.968 0 0 0-.288-.713.968.968 0 0 0-.712-.287.967.967 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.712.192.192.43.288.713.288ZM15.999 19v-4.539H8V19h8Zm1 1H7v-4H3.576V8.615h16.846V16H17v4Zm2.423-5V9.615H4.576V15H7v-1.539h10V15h2.423Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(PrinterFill);
